/* CalmKid : galerie, packs, couleur par CalmKid, ajout au panier, date de livraison, barre collée. */
(function () {
  'use strict';

  /* Cadeaux offerts (guides PDF à 0 €, voir snippets/ck-gifts-data.liquid) : ils suivent le nombre de CalmKid du panier.
     1 CalmKid = le 1er cadeau, 2 = les 2 premiers, 3 ou plus = tous ; un seul exemplaire de chacun ; aucun sans CalmKid. */
  var GIFTS = (function () {
    var el = document.getElementById('ck-gifts-data');
    if (!el) return null;
    try {
      var d = JSON.parse(el.textContent);
      return d && d.main && d.gifts && d.gifts.length ? d : null;
    } catch (e) { return null; }
  })();
  var ROUTES = window.routes || {};
  var CART_URL = ROUTES.cart_url || '/cart';
  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };

  function getCart() {
    return fetch(CART_URL + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function giftsFor(mainQty) {
    return GIFTS ? GIFTS.gifts.slice(0, Math.min(Math.max(mainQty, 0), GIFTS.gifts.length)) : [];
  }
  function mainQtyIn(cart) {
    return cart.items.reduce(function (n, it) { return it.product_id === GIFTS.main ? n + it.quantity : n; }, 0);
  }
  function isGift(it) { return GIFTS.gifts.indexOf(it.variant_id) > -1; }

  /* Remet le panier (tiroir, page panier, pastille du nombre d'articles) à jour après une correction */
  function refreshCartUI(cart) {
    var drawer = document.querySelector('cart-drawer');
    var inner = document.getElementById('CartDrawer');
    if (drawer && inner) {
      fetch(CART_URL + '?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var src = new DOMParser().parseFromString(html, 'text/html').getElementById('CartDrawer');
          if (!src) return;
          inner.innerHTML = src.innerHTML;
          drawer.classList.toggle('is-empty', cart.item_count === 0);
          var overlay = drawer.querySelector('#CartDrawer-Overlay');
          if (overlay && typeof drawer.close === 'function') overlay.addEventListener('click', drawer.close.bind(drawer));
        })
        .catch(function () {});
    }
    var page = document.querySelector('cart-items');
    if (page) {
      if (cart.item_count === 0) window.location.reload();
      else if (typeof page.onCartUpdate === 'function') page.onCartUpdate();
    }
    fetch(CART_URL + '?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (!bubble || !s['cart-icon-bubble']) return;
        var src = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
        if (src) bubble.innerHTML = src.innerHTML;
      })
      .catch(function () {});
  }

  /* Corrige le panier si les cadeaux ne correspondent plus aux CalmKid (quantité changée, CalmKid retiré, cadeau seul…) */
  var syncing = false;
  var syncAgain = false;
  function syncGifts() {
    if (!GIFTS) return;
    if (syncing) { syncAgain = true; return; }
    syncing = true;
    getCart()
      .then(function (cart) {
        var want = giftsFor(mainQtyIn(cart));
        var kept = {};
        var updates = {};
        var changed = false;
        cart.items.forEach(function (it) {
          if (!isGift(it)) return;
          var keep = want.indexOf(it.variant_id) > -1 && !kept[it.variant_id];
          if (keep) kept[it.variant_id] = true;
          var q = keep ? 1 : 0;
          if (it.quantity !== q) { updates[it.key] = q; changed = true; }
        });
        var missing = want.filter(function (id) { return !kept[id]; });
        if (!changed && !missing.length) return null;
        var steps = Promise.resolve();
        if (changed) steps = steps.then(function () {
          return fetch((ROUTES.cart_update_url || '/cart/update') + '.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ updates: updates }) });
        });
        if (missing.length) steps = steps.then(function () {
          return fetch((ROUTES.cart_add_url || '/cart/add') + '.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ items: missing.map(function (id) { return { id: id, quantity: 1 }; }) }) });
        });
        return steps.then(getCart);
      })
      .then(function (cart) { if (cart) refreshCartUI(cart); })
      .catch(function () {})
      .then(function () {
        syncing = false;
        if (syncAgain) { syncAgain = false; syncGifts(); }
      });
  }

  function initGifts() {
    if (!GIFTS || initGifts.done) return;
    initGifts.done = true;
    /* Après chaque changement du panier fait par le thème (quantité, suppression, ajout depuis une autre page) */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, syncGifts);
    /* Au chargement, seulement si le panier n'est pas juste (calculé côté Shopify) */
    if (GIFTS.sync) syncGifts();
  }

  var COLOR_HEX = { turquoise: '#3FB5A5', rose: '#E9A0B4', orange: '#F09A55', gris: '#A9A9A9', vert: '#9CC57A' };
  var COLOR_ALIAS = { bleu: 'turquoise' };

  function slug(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
  }

  /* Trouve le mot de couleur dans le nom de la variante, à n'importe quelle place :
     « Gris koala » → gris, « Flamant rose » → rose. */
  function colorKey(s) {
    var words = slug(s).split(/[^a-z]+/);
    for (var i = 0; i < words.length; i++) {
      var w = COLOR_ALIAS[words[i]] || words[i];
      if (COLOR_HEX[w]) return w;
    }
    return slug(s);
  }

  function addBusinessDays(n) {
    var d = new Date();
    var c = 0;
    while (c < n) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) c++;
    }
    /* Espaces insécables : la date ne se coupe jamais en fin de ligne (« jeu. 15 oct. ») */
    return d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' }).replace(/ /g, '\u00a0');
  }

  function initDelivery(root) {
    root.querySelectorAll('[data-ck-delivery]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 3;
      var max = parseInt(el.getAttribute('data-max'), 10) || 5;
      var a = el.querySelector('[data-d1]');
      var b = el.querySelector('[data-d2]');
      if (a) a.textContent = addBusinessDays(min);
      if (b) b.textContent = addBusinessDays(max);
    });
  }

  function initGallery(root) {
    var main = root.querySelector('.ck-gal-main');
    var thumbs = root.querySelectorAll('.ck-gal-thumbs button');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        var slide = main.children[i];
        if (slide) main.scrollTo({ left: slide.offsetLeft - main.offsetLeft, behavior: 'smooth' });
      });
    });
    /* Les vignettes sont sur une seule ligne qui défile : la vignette de la photo affichée reste visible */
    var strip = root.querySelector('.ck-gal-thumbs');
    var shown = 0;
    function showThumb(i) {
      var b = thumbs[i];
      if (!strip || !b || strip.scrollWidth <= strip.clientWidth) return;
      var left = strip.scrollLeft + (b.getBoundingClientRect().left - strip.getBoundingClientRect().left) - (strip.clientWidth - b.clientWidth) / 2;
      strip.scrollTo({ left: Math.max(0, left), behavior: REDUCED ? 'auto' : 'smooth' });
    }
    var ticking = false;
    main.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var i = Math.round(main.scrollLeft / main.clientWidth);
        thumbs.forEach(function (b, j) { b.setAttribute('aria-current', j === i ? 'true' : 'false'); });
        if (i !== shown) { shown = i; showThumb(i); }
        ticking = false;
      });
    });
  }

  /* « Turquoise tortue » → « Tortue » : le nom de l'animal, sans le mot de couleur */
  function shortName(title) {
    var key = colorKey(title);
    var words = String(title || '').split(/\s+/).filter(function (w) {
      var k = COLOR_ALIAS[slug(w)] || slug(w);
      return k !== key;
    });
    var n = words.join(' ') || String(title || '');
    return n.charAt(0).toUpperCase() + n.slice(1);
  }

  function initOffer(root) {
    var dataEl = root.querySelector('[data-ck-variants]');
    if (!dataEl) return;
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
    var defaults = (root.getAttribute('data-default-colors') || 'Turquoise,Rose,Gris').split(',');
    var colorsBox = root.querySelector('[data-ck-colors]');
    var packs = root.querySelectorAll('.ck-pack');
    var cta = root.querySelector('[data-ck-add]');
    var err = root.querySelector('[data-ck-error]');
    var ctaLabel = cta ? cta.getAttribute('data-label') : 'Ajouter au panier';
    var soldBox = root.querySelector('[data-ck-soldout]');
    var stockBox = root.querySelector('[data-ck-stock]');
    /* La ligne de couleur que le parent a touchée en dernier : le compteur de stock parle de celle-là */
    var activeRow = 0;
    /* Les couleurs choisies, gardées quand le parent change de pack */
    var picks = [];
    var priceShown = false;
    /* Page de vente : l'image de l'offre montre les CalmKid du pack, dans les couleurs choisies */
    /* Deux exemplaires : à gauche sur ordinateur, au-dessus des couleurs sur téléphone */
    var pics = root.querySelectorAll('[data-ck-offer-pic]');

    function renderPic(list) {
      if (!list.length) return;
      pics.forEach(function (pic) { renderOnePic(pic, list); });
    }

    function renderOnePic(pic, list) {
      var picRow = pic.querySelector('[data-ck-offer-pic-row]');
      if (!picRow) return;
      var imgs = picRow.querySelectorAll('img');
      list.forEach(function (c, i) {
        var key = colorKey(c.name);
        if (!pic.getAttribute('data-' + key)) key = 'turquoise';
        var img = imgs[i];
        if (!img) {
          img = document.createElement('img');
          img.alt = '';
          picRow.appendChild(img);
        }
        if (img.getAttribute('data-k') === key) return;
        img.setAttribute('data-k', key);
        img.src = pic.getAttribute('data-' + key);
        img.style.setProperty('--r', pic.getAttribute('data-r-' + key) || '1');
        img.classList.remove('is-in');
        void img.offsetWidth;
        img.classList.add('is-in');
      });
      for (var j = list.length; j < imgs.length; j++) imgs[j].remove();
      pic.setAttribute('data-n', list.length);
    }

    function touch() {
      if (root.dataset.touched === '1') return;
      root.dataset.touched = '1';
      document.dispatchEvent(new CustomEvent('ck:touched'));
    }

    function emitColors() {
      var list = [];
      if (colorsBox) colorsBox.querySelectorAll('.ck-crow').forEach(function (r) {
        var b = r.querySelector('.ck-sw[aria-pressed="true"]');
        if (b) list.push({ hex: b.getAttribute('data-hex'), name: b.getAttribute('aria-label') });
      });
      renderPic(list);
      document.dispatchEvent(new CustomEvent('ck:colors', { detail: list }));
    }

    function availableDefault(i) {
      var kept = picks[i] && variants.find(function (x) { return x.id === picks[i] && x.available; });
      if (kept) return kept.id;
      var wanted = colorKey(defaults[i] || '');
      var v = variants.find(function (x) { return x.available && colorKey(x.title) === wanted; });
      if (!v) v = variants.find(function (x) { return x.available; });
      return v ? v.id : null;
    }

    /* Nombre de lignes de couleurs déjà à l'écran (null = premier affichage, sans animation) */
    var shownRows = null;

    function renderColors(n) {
      if (!colorsBox) return;
      var kept = shownRows === null ? n : shownRows;
      shownRows = n;
      colorsBox.innerHTML = '';
      if (variants.length <= 1) return;
      for (var i = 0; i < n; i++) {
        var chosen = availableDefault(i);
        var row = document.createElement('div');
        /* Une ligne qui était déjà là ne rejoue pas son animation d'apparition */
        row.className = i < kept ? 'ck-crow is-kept' : 'ck-crow';
        var chosenV = variants.find(function (x) { return x.id === chosen; });
        var label = n > 1 ? 'CalmKid ' + (i + 1) : 'Couleur';
        /* Titre court à gauche (« CalmKid 1 »), pastilles à droite ; le nom complet de la couleur reste lu par les lecteurs d'écran */
        var html = '<span class="ck-small ck-crow-label"><b>' + label + '</b><span class="visually-hidden"> · <span data-name>' + (chosenV ? chosenV.title : '') + '</span></span></span><div class="ck-sws" role="group" aria-label="' + label + '">';
        /* Seules les couleurs disponibles sont proposées ; les couleurs épuisées sont listées une seule fois, sous les lignes */
        variants.forEach(function (v) {
          if (!v.available) return;
          var hex = COLOR_HEX[colorKey(v.title)] || '#cccccc';
          html += '<button type="button" class="ck-sw" data-id="' + v.id + '" data-hex="' + hex + '" aria-label="' + v.title + '" aria-pressed="' + (v.id === chosen) + '"><span class="ck-sw-dot" style="--sw:' + hex + '"></span><span class="ck-sw-name">' + shortName(v.title) + '</span></button>';
        });
        row.innerHTML = html + '</div>';
        row.setAttribute('data-selected', chosen || '');
        row.setAttribute('data-i', i);
        picks[i] = chosen;
        row.querySelectorAll('.ck-sw').forEach(function (b) {
          b.addEventListener('click', function () {
            /* La ligne du bouton cliqué (et pas la dernière ligne créée par la boucle) */
            var r = b.closest('.ck-crow');
            r.querySelectorAll('.ck-sw').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
            b.setAttribute('aria-pressed', 'true');
            r.setAttribute('data-selected', b.getAttribute('data-id'));
            r.querySelector('[data-name]').textContent = b.getAttribute('aria-label');
            activeRow = parseInt(r.getAttribute('data-i'), 10);
            picks[activeRow] = Number(b.getAttribute('data-id'));
            touch();
            emitColors();
            renderStock();
          });
        });
        colorsBox.appendChild(row);
      }
      if (soldBox) {
        var gone = variants.filter(function (v) { return !v.available; }).map(function (v) { return v.title; });
        soldBox.hidden = !gone.length;
        /* Phrase optionnelle après la couleur épuisée, avec le nombre de couleurs encore disponibles */
        var more = (soldBox.getAttribute('data-more') || '').replace('{n}', variants.filter(function (v) { return v.available; }).length);
        soldBox.innerHTML = gone.length ? '<span class="ck-sw-dot is-out" aria-hidden="true"></span><span>' + gone.join(', ') + ' : épuisé.' + (more ? ' ' + more : '') + '</span>' : '';
      }
      if (activeRow >= n) activeRow = 0;
      emitColors();
      renderStock();
    }

    /* Compteur de stock bas : le vrai stock Shopify de la couleur choisie, seulement s'il est bas */
    function renderStock() {
      if (!stockBox) return;
      var v = variants.find(function (x) { return x.id === picks[activeRow]; });
      var max = parseInt(stockBox.getAttribute('data-max'), 10) || 10;
      var n = v && typeof v.stock === 'number' ? v.stock : null;
      if (n === null || n < 1 || n > max) { stockBox.hidden = true; return; }
      var t = (stockBox.getAttribute('data-text') || 'Plus que {n} en {couleur}.')
        .replace('{n}', '<b>' + n + '</b>').replace('{couleur}', v.title);
      stockBox.querySelector('[data-ck-stock-t]').innerHTML = t;
      stockBox.querySelector('.ck-stock-bar i').style.width = Math.max(6, Math.round(n / 20 * 100)) + '%';
      stockBox.hidden = false;
    }

    function selectPack(pack) {
      packs.forEach(function (p) { p.classList.toggle('is-on', p === pack); });
      pics.forEach(function (pic) {
        var n = pic.querySelector('[data-ck-offer-pic-n]');
        if (n) n.textContent = pack.getAttribute('data-short') || '';
      });
      var qty = parseInt(pack.getAttribute('data-qty'), 10) || 1;
      renderColors(qty);
      var price = pack.getAttribute('data-price') || '';
      if (cta) {
        var t = document.createElement('span');
        t.className = 'ck-cta-t';
        t.textContent = ctaLabel + (price ? ' · ' : '');
        var pr = document.createElement('span');
        pr.className = 'ck-cta-price';
        pr.textContent = price;
        if (price) t.appendChild(pr);
        cta.replaceChildren(t);
        /* Le nouveau prix monte en place quand le parent change de pack (pas au chargement de la page) */
        if (priceShown) ckPriceIn(pr);
        priceShown = true;
      }
      document.dispatchEvent(new CustomEvent('ck:pack', { detail: { qty: qty, name: pack.getAttribute('data-short') || '', price: price } }));
    }

    /* Changer de pack ne fait jamais défiler la page (demande de Dimitri, 2026-10-15) : les cartes s'ouvrent
       et se ferment sur place. Avant, la page compensait pour garder la carte sous le doigt, et remontait
       d'un cran à chaque aller-retour (3 → 2 → 3…) jusqu'en haut.
       Pendant l'animation, l'ancrage automatique du navigateur est coupé : sinon, il ferait lui-même défiler la page. */
    var anchorTimer = null;
    function freezeScroll() {
      var html = document.documentElement;
      if (anchorTimer === null) html.dataset.ckAnchor = html.style.overflowAnchor || '';
      else clearTimeout(anchorTimer);
      html.style.overflowAnchor = 'none';
      anchorTimer = setTimeout(function () {
        html.style.overflowAnchor = html.dataset.ckAnchor || '';
        delete html.dataset.ckAnchor;
        anchorTimer = null;
      }, 500);
    }

    packs.forEach(function (p) {
      var input = p.querySelector('input');
      if (!input) return;
      input.addEventListener('change', function () {
        freezeScroll();
        selectPack(p);
        touch();
      });
    });
    var start = root.querySelector('.ck-pack input:checked');
    if (start) selectPack(start.closest('.ck-pack'));
    else if (packs[0]) { packs[0].querySelector('input').checked = true; selectPack(packs[0]); }

    if (cta) {
      cta.addEventListener('click', function () {
        if (err) err.hidden = true;
        var ids = [];
        if (colorsBox && colorsBox.children.length) {
          colorsBox.querySelectorAll('.ck-crow').forEach(function (r) { var id = r.getAttribute('data-selected'); if (id) ids.push(Number(id)); });
        } else {
          var v = variants.find(function (x) { return x.available; });
          var qty = parseInt((root.querySelector('.ck-pack.is-on') || {}).getAttribute ? root.querySelector('.ck-pack.is-on').getAttribute('data-qty') : 1, 10) || 1;
          for (var k = 0; k < qty && v; k++) ids.push(v.id);
        }
        if (!ids.length) { if (err) { err.textContent = 'Cette couleur est épuisée. Choisissez-en une autre.'; err.hidden = false; } return; }
        var merged = {};
        ids.forEach(function (id) { merged[id] = (merged[id] || 0) + 1; });
        var items = Object.keys(merged).map(function (id) { return { id: Number(id), quantity: merged[id] }; });
        var drawer = document.querySelector('cart-drawer');
        var body = { items: items };
        if (drawer && drawer.getSectionsToRender) {
          body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
        }
        cta.disabled = true;
        /* Les cadeaux du pack partent avec les CalmKid, dans la même requête (sans doublon s'ils sont déjà au panier) */
        var giftsToAdd = GIFTS
          ? getCart()
            .then(function (cart) {
              var have = {};
              cart.items.forEach(function (it) { if (isGift(it)) have[it.variant_id] = true; });
              return giftsFor(mainQtyIn(cart) + ids.length).filter(function (id) { return !have[id]; });
            })
            .catch(function () { return giftsFor(ids.length); })
          : Promise.resolve([]);
        giftsToAdd
          .then(function (gifts) {
            /* Le panier montre en premier le dernier article ajouté. Ordre envoyé : cadeau 3, 2, 1, puis les CalmKid,
               pour un panier affiché « CalmKid, guide, programme, manuel » */
            gifts.forEach(function (id) { items.unshift({ id: id, quantity: 1 }); });
            return fetch((ROUTES.cart_add_url || '/cart/add') + '.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify(body) });
          })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
          .then(function (res) {
            cta.disabled = false;
            if (!res.ok) { if (err) { err.textContent = res.json.description || 'Une erreur est survenue. Réessayez.'; err.hidden = false; } return; }
            if (drawer && drawer.renderContents && res.json.sections) {
              drawer.classList.remove('is-empty');
              drawer.renderContents(res.json);
              document.dispatchEvent(new CustomEvent('ck:added'));
            } else {
              window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            }
          })
          .catch(function () {
            cta.disabled = false;
            if (err) { err.textContent = 'Connexion impossible. Vérifiez votre réseau et réessayez.'; err.hidden = false; }
          });
      });
    }
  }

  function initSticky() {
    var bar = document.querySelector('[data-ck-sticky]');
    var offer = document.querySelector('[data-ck-add]');
    if (!bar || !offer || bar.dataset.ckInit) return;
    bar.dataset.ckInit = '1';
    var root = offer.closest('[data-ck-offer]');
    var txt = bar.querySelector('[data-ck-sticky-txt]');
    var dots = bar.querySelector('[data-ck-sticky-dots]');
    var btn = bar.querySelector('[data-ck-sticky-btn]');
    function setText(name, price) {
      if (!txt || !name) return;
      var old = txt.querySelector('b');
      var changed = old && old.textContent !== price;
      txt.innerHTML = name + ' · <b>' + price + '</b>';
      if (changed) ckPriceIn(txt.querySelector('b'));
    }
    function touched() { return root && root.dataset.touched === '1'; }
    function setLabel() {
      if (!btn) return;
      var add = btn.getAttribute('data-label-add') || 'Ajouter au panier';
      var choose = btn.getAttribute('data-label-choose') || add;
      btn.textContent = touched() ? add : choose;
    }
    /* Page de vente (haut de page sans prix, offre plus bas) : la barre revient dès le haut de page passé,
       mais elle ne montre le prix qu'une fois l'offre vue. Elle se cache pendant que l'offre est à l'écran. */
    var top = document.getElementById('ck-haut');
    var offerBox = document.getElementById('ck-offre');
    var sales = !!(top && offerBox && offerBox.contains(offer));
    var seen = !sales;
    function packText() {
      var on = document.querySelector('.ck-pack.is-on');
      if (on) setText(on.getAttribute('data-short'), on.getAttribute('data-price'));
    }
    document.addEventListener('ck:pack', function (e) { if (seen) setText(e.detail.name, e.detail.price); });
    document.addEventListener('ck:touched', setLabel);
    document.addEventListener('ck:colors', function (e) {
      if (!dots) return;
      dots.innerHTML = e.detail.map(function (c) { return '<span class="ck-sw-dot" style="--sw:' + c.hex + '" title="' + c.name + '"></span>'; }).join('');
    });
    if (seen) packText();
    setLabel();
    /* Tant que le parent n'a rien choisi, le bouton le ramène au choix du pack.
       Ensuite, il ajoute au panier le pack et les couleurs qu'il a vus. */
    if (btn) btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (!touched()) {
        var packs = document.getElementById('ck-packs');
        if (packs) {
          packs.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'start' });
          var checked = packs.querySelector('input:checked');
          if (checked) checked.focus({ preventScroll: true });
        }
        return;
      }
      if (offer.disabled) return;
      offer.click();
    });
    /* Visible seulement quand le vrai bouton n'est pas à portée du pouce. Recalculé à chaque défilement,
       y compris après un saut de lien (« Voir le contenu », « Choisir mon pack »).
       Dans l'offre : la barre revient dès que le parent a choisi un pack ou une couleur ET que le vrai
       bouton est sous l'écran (sur téléphone, il est à plus d'un écran sous les packs). Dès que le vrai
       bouton arrive à l'écran, la barre se cache : jamais deux boutons d'achat en même temps. */
    var ticking = false;
    function check() {
      ticking = false;
      var past;
      var b = offer.getBoundingClientRect();
      var btnInView = b.top < window.innerHeight - 70 && b.bottom > 0;
      if (sales) {
        var o = offerBox.getBoundingClientRect();
        var inOffer = o.top < window.innerHeight && o.bottom > 0;
        if (!seen && o.top < window.innerHeight) { seen = true; packText(); }
        past = top.getBoundingClientRect().bottom < 0 && (!inOffer || (touched() && !btnInView));
      } else {
        past = b.bottom < 0 || (touched() && !btnInView && b.top > 0);
      }
      bar.classList.toggle('is-visible', past);
      document.body.classList.toggle('ck-has-sticky', past);
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(check); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    window.addEventListener('hashchange', function () { setTimeout(check, 60); });
    /* Un pack qui s'ouvre ou se ferme déplace le bouton sans défilement : on recalcule aussi à ce moment-là. */
    ['ck:touched', 'ck:pack', 'ck:colors'].forEach(function (name) { document.addEventListener(name, onScroll); });
    if (window.ResizeObserver) new ResizeObserver(onScroll).observe(root || document.body);
    check();
  }

  /* L'illustration de la main : le rythme suit le mode choisi, et s'arrête hors de l'écran. */
  function initPalm() {
    document.querySelectorAll('[data-ck-palm]').forEach(function (box) {
      if (box.dataset.ckInit) return;
      box.dataset.ckInit = '1';
      var btns = box.querySelectorAll('[data-ck-mode]');
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          btns.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
          box.setAttribute('data-mode', b.getAttribute('data-ck-mode'));
        });
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          en.forEach(function (e) { box.classList.toggle('is-off', !e.isIntersecting); });
        }).observe(box);
        /* La première fois que la main est bien en vue, CalmKid vient s'y poser (0,9 s), puis les impulsions démarrent. */
        if (!REDUCED) {
          box.classList.add('ck-arrive-on');
          var arrive = new IntersectionObserver(function (en) {
            en.forEach(function (e) {
              if (!e.isIntersecting) return;
              arrive.disconnect();
              box.classList.add('is-in');
              setTimeout(function () { box.classList.add('is-landed'); }, 800);
            });
          }, { rootMargin: '0px 0px -35% 0px' });
          arrive.observe(box);
        }
      }
    });
  }

  /* Bandeau solution : 2 impulsions autour de CalmKid quand il est bien en vue, une seule fois. */
  function initBandPulse() {
    if (REDUCED || !('IntersectionObserver' in window)) return;
    document.querySelectorAll('.ck-band-dev, .ck-anat-dev').forEach(function (el) {
      if (el.dataset.ckPulse) return;
      el.dataset.ckPulse = '1';
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.disconnect();
          setTimeout(function () { el.classList.add('is-on'); }, 250);
        });
      }, { rootMargin: '0px 0px -45% 0px' });
      io.observe(el);
    });
  }

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* La courbe de mouvement unique du site (douce à l'arrivée, comme les feuilles d'iOS) */
  var EASE = 'cubic-bezier(.32, .72, 0, 1)';
  /* Sur iPhone, Safari n'applique l'état « appuyé » (:active) que si la page écoute le toucher */
  document.addEventListener('touchstart', function () {}, { passive: true });

  /* Les chiffres défilent de 0 à leur valeur. Sans JavaScript, la vraie valeur reste affichée. */
  function initCount() {
    if (REDUCED || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        var el = en.target;
        var m = el.textContent.match(/^(\D*)(\d+)(.*)$/);
        if (!m) return;
        var end = parseInt(m[2], 10), t0 = null, dur = 1200, finalText = el.textContent;
        setTimeout(function () { el.textContent = finalText; }, dur + 150);
        function step(ts) {
          if (!t0) t0 = ts;
          var p = Math.min(1, (ts - t0) / dur);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = m[1] + Math.round(end * eased) + m[3];
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.6 });
    document.querySelectorAll('.ck-stat b').forEach(function (el) {
      if (el.dataset.ckCount) return;
      el.dataset.ckCount = '1';
      io.observe(el);
    });
  }

  /* Les questions de la FAQ s'ouvrent et se ferment en glissant. */
  /* Un prix qui change monte en place (petit glissement + fondu), pour que le parent voie l'effet de son choix. */
  function ckPriceIn(el) {
    if (!el || !el.animate) return;
    var frames = REDUCED ? [{ opacity: 0 }, { opacity: 1 }] : [{ opacity: 0, transform: 'translateY(.45em)' }, { opacity: 1, transform: 'none' }];
    el.animate(frames, { duration: REDUCED ? 150 : 280, easing: EASE });
  }

  /* FAQ : on peut toucher une question pendant qu'elle s'ouvre ou se ferme. L'animation repart
     de la hauteur affichée à l'écran, vers le dernier choix du parent (avant : 3 touchers rapides = mauvais état). */
  function initFaq() {
    document.querySelectorAll('.ck details.ck-faq-q').forEach(function (d) {
      if (d.dataset.ckFaq) return;
      d.dataset.ckFaq = '1';
      var sum = d.querySelector(':scope > summary');
      var body = d.querySelector(':scope > .ck-faq-a');
      if (!sum || !body || REDUCED || !body.animate) return;
      var anim = null;
      var wantOpen = d.open;
      sum.addEventListener('click', function (e) {
        e.preventDefault();
        wantOpen = !wantOpen;
        var from = d.open ? body.getBoundingClientRect().height : 0;
        var fromOp = anim ? parseFloat(getComputedStyle(body).opacity) : (d.open ? 1 : 0);
        if (anim) { anim.onfinish = null; anim.cancel(); anim = null; }
        d.open = true;
        d.classList.toggle('is-closing', !wantOpen);
        var full = body.scrollHeight;
        var to = wantOpen ? full : 0;
        var dur = Math.max(140, Math.round(260 * Math.abs(to - from) / Math.max(full, 1)));
        anim = body.animate([{ height: from + 'px', opacity: fromOp }, { height: to + 'px', opacity: wantOpen ? 1 : 0 }], { duration: dur, easing: EASE });
        anim.onfinish = function () {
          anim = null;
          d.classList.remove('is-closing');
          if (!wantOpen) d.open = false;
        };
      });
    });
  }

  /* Avis : onglets Tous / Coucher / Crises / Devoirs (la liste reste verticale). */
  function initTabs() {
    document.querySelectorAll('[data-ck-tabs]').forEach(function (bar) {
      if (bar.dataset.ckInit) return;
      bar.dataset.ckInit = '1';
      var root = bar.closest('.ck') || document;
      var btns = bar.querySelectorAll('[data-ck-tab]');
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          var want = b.getAttribute('data-ck-tab');
          btns.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
          root.querySelectorAll('.ck-rev').forEach(function (r) {
            r.hidden = !!want && r.getAttribute('data-moment') !== want;
          });
          if (want) root.querySelectorAll('details.ck-more').forEach(function (d) { if (d.querySelector('.ck-rev')) d.open = true; });
        });
      });
    });
  }

  /* « Code activé » (snippet ck-code-actif, 2026-10-23) : le petit script du snippet l'affiche dès que le cookie
     discount_code existe (lien /discount/CODE des e-mails). Ici, on le recache si le panier contient des articles
     et que Shopify dit que le code ne s'applique pas (code expiré, déjà utilisé…). Panier vide : Shopify ne sait pas encore. */
  function initCode() {
    var els = document.querySelectorAll('[data-ck-code]');
    if (!els.length) return;
    function check() {
      var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
      var code = m ? decodeURIComponent(m[1]).toUpperCase() : '';
      if (!code) { els.forEach(function (el) { el.hidden = true; }); return; }
      getCart().then(function (cart) {
        var ok = !cart.item_count || (cart.discount_codes || []).some(function (d) { return d.applicable && String(d.code).toUpperCase() === code; });
        els.forEach(function (el) { el.hidden = !ok; });
      }).catch(function () {});
    }
    check();
    if (initCode.done) return;
    initCode.done = true;
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, check);
    document.addEventListener('ck:added', check);
  }

  function init() {
    initCount();
    initTabs();
    initFaq();
    document.querySelectorAll('[data-ck-offer]').forEach(function (root) {
      initGallery(root);
      initOffer(root);
    });
    initDelivery(document);
    initSticky();
    initPalm();
    initBandPulse();
    initGifts();
    initCode();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
